import { render, staticRenderFns } from "./PreRegistrationRequiredInfoModal.vue?vue&type=template&id=88a430f8&scoped=true&"
import script from "./PreRegistrationRequiredInfoModal.vue?vue&type=script&lang=js&"
export * from "./PreRegistrationRequiredInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a430f8",
  null
  
)

export default component.exports